import debounce from '../helpers/debounce';

// Function to handle navigation menu (list view + sticky menu)
export default function initializeFixedMenu() {
    // Check if menu exists
    const navigationMenu = document.querySelector('.navigation-menu');
    const menuListView = document.querySelector('.menu-list-view');
    const stickyMenu = document.querySelector('.sticky-menu');

    if (!navigationMenu || !menuListView || !stickyMenu) {
        console.error('Menu elements not found!');
        return;
    }

    // Handle scroll to show/hide sticky menu
    function handleMenuVisibility() {
        const modal = document.querySelector('.modal--active');
        const scrollPosition = modal ? modal.scrollTop : window.scrollY;
        const wynikiTop = document.getElementById('wyniki')?.offsetTop ?? 1200;

        if (scrollPosition > wynikiTop - 50) {
            stickyMenu?.classList.add('sticky-menu--visible');
        } else {
            stickyMenu?.classList.remove('sticky-menu--visible');
        }
    }

    // Smooth scrolling for all menu links (both list and sticky)
    const allMenuLinks = document.querySelectorAll('.menu-list-item[href], .menu-item[href]');

    if (allMenuLinks.length === 0) {
        console.error('No menu links found!');
        return;
    }

    allMenuLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default to control scrolling manually
            const sectionId = this.getAttribute('href').split('=').pop().trim();
            const targetElement = document.querySelector('#' + sectionId);

            if (targetElement && 'offsetTop' in targetElement) {
                let menuHeight = 100;
                const offset = 20; // Additional offset for better spacing

                const targetPosition = Number(targetElement.offsetTop) - menuHeight - offset;

                // Check if we're inside a modal
                const modal = document.querySelector('.modal--active');
                if (modal) {
                    // Scroll the modal container instead of window
                    modal.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                } else {
                    // Standard window scrolling
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }

                // Update URL to include query param i and hash
                setTimeout(() => {
                    const newUrl = `?i=${sectionId}`;
                    history.pushState(null, '', newUrl);
                }, 100);
            } else {
                console.error('Target element not found: #', sectionId);
            }
        });
    });

    // Highlight active menu item based on scroll position
    function updateActiveMenuItem(skipUrlUpdate = false) {
        const sections = document.querySelectorAll('section[id]');
        const stickyMenuItems = document.querySelectorAll('.sticky-menu .menu-item[href]');
        const listMenuItems = document.querySelectorAll('.menu-list-item[href]');

        let menuHeight = 100;

        // Check if we're inside a modal and get scroll position accordingly
        const modal = document.querySelector('.modal--active');
        const scrollPosition = modal ? modal.scrollTop + menuHeight + 50 : window.scrollY + menuHeight + 50;

        let activeSection = null;

        sections.forEach(section => {
            if ('offsetTop' in section && 'offsetHeight' in section) {
                const sectionTop = Number(section.offsetTop);
                const sectionBottom = sectionTop + Number(section.offsetHeight);

                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    activeSection = section.id;
                }
            }
        });

        // Remove active class from all menu items (both sticky and list)
        stickyMenuItems.forEach(item => {
            item.classList.remove('menu-item--active');
        });
        listMenuItems.forEach(item => {
            item.classList.remove('menu-list-item--active');
        });

        // Add active class to current section's menu items
        if (activeSection) {
            const activeStickyMenuItem = document.querySelector(`.sticky-menu .menu-item[href="?i=${activeSection}"]`);
            const activeListMenuItem = document.querySelector(`.menu-list-item[href="?i=${activeSection}"]`);

            if (activeStickyMenuItem) {
                activeStickyMenuItem.classList.add('menu-item--active');
            }
            if (activeListMenuItem) {
                activeListMenuItem.classList.add('menu-list-item--active');
            }

            // Update URL without adding to history
            if (!skipUrlUpdate) {
                const url = new URL(window.location);
                if (url.searchParams.get('i') !== activeSection) {
                    url.searchParams.set('i', activeSection);
                    history.replaceState(null, '', url.toString());
                }
            }
        }
    }

    // Combined scroll handler
    const debouncedHandleScroll = debounce(() => {
        handleMenuVisibility();
        updateActiveMenuItem();
    }, 100); // Debounce by 100ms

    // Update on scroll
    const modal = document.querySelector('.modal--active');
    if (modal) {
        modal.addEventListener('scroll', debouncedHandleScroll);
    } else {
        window.addEventListener('scroll', debouncedHandleScroll);
    }

    // Handle direct hash navigation (e.g., when user enters URL with hash)
    function handleHashNavigation() {
        const sectionId = getSectionId()
        if (!sectionId) return false

        const targetSelector = `#${sectionId}`;
        const targetElement = document.querySelector(targetSelector);
        if (targetElement && 'offsetTop' in targetElement) {
            setTimeout(() => {
                let menuHeight = 100;
                const offset = 20;
                const targetPosition = Number(targetElement.offsetTop) - menuHeight - offset;

                // Check if we're inside a modal
                const modal = document.querySelector('.modal--active');
                if (modal) {
                    modal.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                } else {
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100);
            return true;
        }
        return false;
    }

    // Handle hash navigation on page load and hash change
    window.addEventListener('hashchange', handleHashNavigation);

    // Initial calls
    handleMenuVisibility();
    const isNavigating = handleHashNavigation(); // Call on initial load
    updateActiveMenuItem(isNavigating);
}

function getSectionId() {

    const urlParams = new URLSearchParams(window.location.search);
    let sectionId = urlParams.get('i')
    if (sectionId) {
        return sectionId
    }

    const hboxId = urlParams.get('h')
    if (hboxId) {
        const hbox = document.getElementById(hboxId)
        sectionId = hbox?.dataset.sectionId
    }

    if (sectionId) {
        return sectionId
    }
    return null
}